import React from 'react';

class DateTriplet extends React.Component {
  handleChange = (part, raw) => {
    const { value, onChange } = this.props;
    if (!onChange) return;
    const digitsOnly = (raw || '').replace(/\D/g, '');
    const next = { day: '', month: '', year: '', ...(value || {}), [part]: digitsOnly };
    onChange(next);
  };

  render() {
    const { value, label, required, id, fieldId, error } = this.props;
    const safe = { day: '', month: '', year: '', ...(value || {}) };
    const baseId = id || (label ? label.toLowerCase().replace(/[^a-z0-9]+/g, '_') : 'date');
    const hasError = !!error;
    const borderColor = hasError ? '#DC2626' : '#D1D5DB';

    return (
      <div data-field-id={fieldId || undefined}>
        {label ? (
          <label className="block text-sm font-medium text-[#1F2937] mb-2">
            {label}
            {required ? <span className="text-[#DC2626] ml-1">*</span> : null}
          </label>
        ) : null}
        <div className="flex gap-2 items-end">
          <div className="flex-1 min-w-0">
            <span className="block text-xs text-[#6B7280] mb-1">Day</span>
            <input
              id={`${baseId}_day`}
              type="text"
              inputMode="numeric"
              maxLength={2}
              required={required}
              placeholder="DD"
              value={safe.day}
              onChange={(e) => this.handleChange('day', e.target.value)}
              aria-invalid={hasError || undefined}
              className="dui-input dui-input-bordered w-full text-center"
              style={{ borderColor }}
            />
          </div>
          <div className="flex-1 min-w-0">
            <span className="block text-xs text-[#6B7280] mb-1">Month</span>
            <input
              id={`${baseId}_month`}
              type="text"
              inputMode="numeric"
              maxLength={2}
              required={required}
              placeholder="MM"
              value={safe.month}
              onChange={(e) => this.handleChange('month', e.target.value)}
              aria-invalid={hasError || undefined}
              className="dui-input dui-input-bordered w-full text-center"
              style={{ borderColor }}
            />
          </div>
          <div className="flex-[1.4] min-w-0">
            <span className="block text-xs text-[#6B7280] mb-1">Year</span>
            <input
              id={`${baseId}_year`}
              type="text"
              inputMode="numeric"
              maxLength={4}
              required={required}
              placeholder="YYYY"
              value={safe.year}
              onChange={(e) => this.handleChange('year', e.target.value)}
              aria-invalid={hasError || undefined}
              className="dui-input dui-input-bordered w-full text-center"
              style={{ borderColor }}
            />
          </div>
        </div>
        {hasError ? (
          <p className="mt-1 text-xs font-medium text-[#DC2626]">{error}</p>
        ) : null}
      </div>
    );
  }
}

export default DateTriplet;
